'use client';

import { JSX, useEffect, useState } from 'react';

interface TimeoutProps {
	children: React.ReactNode;
	timeout: number;
	fallback?: () => JSX.Element | React.ReactNode;
}

function Timeout(props: TimeoutProps) {
	// States
	const [isTimeout, setIsTimeout] = useState(false);

	// Effects
	useEffect(() => {
		const timeout = setTimeout(() => {
			setIsTimeout(true);
		}, props.timeout);

		return () => clearTimeout(timeout);
	}, [props.timeout]);

	return isTimeout ? (
		props.children
	) : props.fallback ? (
		<props.fallback />
	) : null;
}

export default Timeout;
